import { LifeBuoy } from 'lucide-react'
import { SupportSpaceFields } from '@/components/features/support/SupportSpaceFields'
import {
  defaultSupportConfig,
  supportConfigApiErrors,
  supportConfigFrom,
  toSupportInput,
  validateSupportConfig
} from '@/components/features/support/supportUtils'
import type { ModuleDefinition } from '../types'
import { lazyPage } from '@/lib/lazyPage'

const SupportPage = lazyPage(() => import('@/pages/Support'), 'SupportPage')
const SupportDetailPage = lazyPage(() => import('@/pages/SupportDetail'), 'SupportDetailPage')

export const supportModule: ModuleDefinition = {
  key: 'support',
  icon: LifeBuoy,
  iconName: 'life-buoy',
  namespaces: ['support'],
  ready: true,
  ListPage: SupportPage,
  /* `/{section}/{space}/{ticketId}`: the requester and the team open a ticket; anyone else gets a 404 from the API. */
  renderDetail: ({ spaceData }) => <SupportDetailPage spaceId={spaceData.id} spaceData={spaceData} />,
  /* Responders and per-category deadlines have a body of their own: a third step (PADROES-UI section 14), in `Space.moduleConfig.support`. */
  setup: {
    wizardStep: 'own',
    stepLabelKey: 'support:config.stepLabel',
    stepHintKey: 'support:config.stepHint',
    defaultConfig: () => defaultSupportConfig(),
    validate: (config, t) => validateSupportConfig(config, t),
    errorsFromApi: (err) => supportConfigApiErrors(err),
    Fields: SupportSpaceFields,
    persist: {
      type: 'moduleConfig',
      toModuleConfig: (config, stored) => ({ ...(stored || {}), support: { ...(stored?.support || {}), ...toSupportInput(config) } }),
      fromSpace: (space) => supportConfigFrom(space.moduleConfig?.support)
    }
  }
}
